"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'register.complete.hero.title': '欢迎来到IntHub！',
    'register.complete.hero.description': '您的账户已成功创建。请查看您的电子邮件以激活您的账户。',
    'register.complete.email.check': '请检查您的电子邮件收件箱并点击激活链接以完成注册。',
    'register.complete.login.button': '前往登录',
    'register.complete.home.button': '返回首页',
    'register.complete.help.text': '需要帮助？',
    'register.complete.help.link': '联系支持',
    'register.complete.title': '注册完成！',
    'register.complete.description': '感谢您注册IntHub。我们已向您的注册邮箱地址发送了激活邮件。',
    'register.complete.email.sent': '邮件已发送至',
    'register.complete.button.login': '去登录',
    'register.complete.button.resend': '重新发送激活邮件',
    'register.complete.help.check_spam': '如果您在收件箱中看不到邮件，请检查垃圾邮件文件夹。',
    'register.complete.help.contact_support': '如果您需要帮助，请联系我们的支持团队。',
    'register.complete.resend.success': '激活邮件重新发送成功！',
};
